import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable, computedFrom, Disposable } from 'aurelia-framework';
import { IReportAM, ReportService } from './report-api';
import { ReportingStateService } from "./reporting-state-service";
import { ReportEditSwapStore } from "./report-route-store";
import { ReportFinancialPrecision } from "./models/report-template";

interface IReportViewUrlParams {
	reportId: string;
	customerId: string;
}

@autoinject
export class ReportView {

	@bindable reportTemplateId: string;

	report: IReportAM;
	isLoadErroneous: boolean;
	routeProcessingSubscriber: Disposable;

	constructor(private reportService: ReportService,
		private reportingStateService: ReportingStateService,
		private eventAggregator: EventAggregator,
		private routeSwapStore: ReportEditSwapStore) {

		this.routeProcessingSubscriber = this.eventAggregator.subscribe(`router:navigation:processing`, ev => {
			if(ev.instruction.config.name === 'edit-report') {
				// If the new route will be edit-report we store the report data to store so we wont have 
				// to fetch the same data from server
				this.routeSwapStore.store = this.report;
			}
		});
	}

	@computedFrom("report")
	get financialPrecision(): ReportFinancialPrecision {
		return this.report.financialPrecision;
	}

	activate(urlParams: IReportViewUrlParams) {
		this.reportTemplateId = urlParams.reportId;
		this.loadReport(urlParams.customerId);
	}

	async loadReport(customerId: string) {
		this.report = await this.reportService.getReportForCustomer(this.reportTemplateId, customerId, false, e => { this.isLoadErroneous = true; });
		this.reportingStateService.setReportToExport({
			name: this.report.heading,
			id: this.reportTemplateId,
			isFolder: false
		});
	}
	
	detached() {
		this.reportingStateService.removeReportToExport();
		this.routeProcessingSubscriber.dispose();
	}
}
